__turbopack_context__.v({
  "className": "LWQFtq_className",
  "variable": "LWQFtq_variable",
});
